import React from "react";
// import Cards from "../Cards/Cards";
import Table from "../Table/Table";
import "./MainDash.css";
const MainDash = ({item}) => {
    return (
        <div className="MainDash">
            <h1 className="text-2xl">Dashboard</h1>
            {/* <Cards /> */}
            <Table item={item} />
        </div>
    );
};

export default MainDash;
